import { render, staticRenderFns } from "./P_2020-portfolio.vue?vue&type=template&id=12e4b004&scoped=true&"
import script from "./P_2020-portfolio.vue?vue&type=script&lang=js&"
export * from "./P_2020-portfolio.vue?vue&type=script&lang=js&"
import style0 from "./P_2020-portfolio.vue?vue&type=style&index=0&id=12e4b004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4b004",
  null
  
)

export default component.exports